module.exports = "/images/by.svg?6e4be82cd0b6d696e9630f3902ec772c";